export default __webpack_public_path__ + "static/media/website-terms.5f44cfba.svg";